import React, {useEffect, useState} from 'react';
import Guid from 'guid';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {useHistory} from 'react-router-dom';
import {withTranslation} from 'react-i18next';

import Cart from '../components/Cart';
import IPosModal from '../../IPosModal';
import SplitPaymentSelector from './components/SplitPaymentSelector';
import ZCreditWebCheckoutIframe from './components/ZcreditWebCheckoutIframe';
import {clearClientInfo, updateClientInfo} from '../../redux/actions/clientActions';
import {PaymentType} from '../../constants/paymentTypes';
import {setSelectedItem} from '../../redux/actions/menuActions';
import {clearOrder, submitOrder, dejavooCreateSession} from '../../redux/actions/orderActions';
import {setValueCardInfo, setSelectedValueCardBenefits, setValueCardBenefitsResponse, setValueCardItem} from '../../redux/actions/valueCardAction';
import {setDeliveryType, setOrderGuidCode, setOrderType, setTableId, setOrderTips} from '../../redux/actions/baseActions';
import {clearCostDelivery} from '../../redux/actions/costDeliveryActions';
import {sendConfirmationCode} from '../../redux/actions/paymentActions';
import {orderTotal} from '../../redux/selectors/order';
import {hideLoading, showLoading} from '../../redux/actions/loadingActions';

import './PaymentPage.scss';

const personObj = {
  amount: null
};

const PaymentPage = ({
                       updateClientInfo,
                       clientInfo,
                       branchInfo,
                       t,
                       submitOrder,
                       dejavooCreateSession,
                       setOrderType,
                       paymentTypes,
                       clearOrder,
                       setDeliveryType,
                       setOrderGuidCode,
                       clearClientInfo,
                       clearCostDelivery,
                       sendConfirmationCode,
                       orderTotalAmount,
                       showLoading,
                       hideLoading,
                       currentTableId,
                       orderTips,
                       currentDeliveryType,
                       setTableId,
                       setOrderTips,
                       setValueCardInfo, 
                       setSelectedValueCardBenefits, 
                       setValueCardBenefitsResponse, 
                       setValueCardItem,
                       setSelectedItem
                     }) => {

  const history = useHistory();  
  const [orderUuid, setOrderUuid] = useState(null);
  const [confCode, setConfCode] = useState(null);
  const [amountLeft, setAmountLeft] = useState(null);
  const [currentView, setCurrentView] = useState('payments');
  const [dejavooIframeUrl, setDejavooIframeUrl] = useState(null);

  const [persons, setPersons] = useState([Object.assign({}, personObj, {
    amount: orderTotalAmount / 100,
    uuid: Guid.create().value
  })]);

  const addPerson = (newPerson) => {
    if (persons.length === 1 && !newPerson.amount && persons[0].amount > 0) {
      const existingPerson = Object.assign({}, persons[0], {amount: null});
      setPersons([existingPerson, newPerson]);
      return;
    }

    setPersons(state => [...state, newPerson]);
  };

  const removePerson = (personToDelete) => {
    const newPersons = persons.filter((p) => {
      return p.uuid !== personToDelete.uuid;
    });
    setPersons(newPersons);
  };

  const updatePerson = personToUpdate => setPersons((persons) => {
    return persons.map((p) => {
      if (p.uuid === personToUpdate.uuid) {
        return personToUpdate;
      } else {
        return p;
      }
    });
  });

  useEffect(() => {
    const paymentAmount = persons.reduce((acc, p) => {
      return acc + p.amount;
    }, 0);

    const leftToPay = (orderTotalAmount / 100) - paymentAmount;
    // setAmountLeft( leftToPay > 0 ? leftToPay : 0);
    setAmountLeft(leftToPay);
  }, [persons]);

  useEffect(() => {
    if (persons.length === 1 && (!persons[0].amount || persons[0].amount < orderTotalAmount / 100)) {
      const person = Object.assign({}, persons[0], {amount: orderTotalAmount / 100, tipsAmount: orderTips / 100 });
      updatePerson(person);
    }
  }, [persons]);  

  const goBack = () => {
    history.push(`/${branchInfo.branch_guid_code}/client`);
  };

  const formatError = (message) => {
    return (
      <div>
        <div>{message}</div>
      </div>
    );
  };

  const isDataValid = () => {
    return !persons.some(p => !isPersonDataValid(p));
  };

  const isPersonDataValid = (person) => {
    if (!person.amount || person.amount === 0) {
      return false;
    }

    if (person.paymentType && (person.paymentType.payment_code === PaymentType.TEN_BIS || person.paymentType.payment_code === PaymentType.CIBUS) && person.cardData) {
      if (person.cardData.cardNumber) {
        return true;
      } else {
        return false;
      }

    }

    if (person.paymentType && person.paymentType.payment_code === PaymentType.CREDIT_CARD && (person.cardData || branchInfo.use_pin_pad_flg === 1 || branchInfo.is_zcreditwc_flg === 1)) {
      if (branchInfo.use_pin_pad_flg === 1) {
        return true;
      }

      if (branchInfo.is_zcreditwc_flg === 1) {
        return true;
      }

      if (person.cardData.cardNumber && person.cardData.expiryMonth && person.cardData.expiryYear && person.cardData.cvc && person.cardData.passport) {
        return true;
      } else {
        return false;
      }
    }

    if (person.paymentType && [PaymentType.CASH, PaymentType.WAITER].includes(person.paymentType.payment_code)) {
      return true;
    }
    return false;
  };

  const proceedCashCheckout = async () => {
    const guidCode = await sendConfirmationCode(clientInfo.clientMobile);
    setOrderUuid(guidCode);
    hideLoading();

    IPosModal.confirmationCode({
      t: t,
      okButtonText: t('buttons.continue'),
      cancelButtonText: t('buttons.cancel'),
      onOk: onSetConfirmationCode,
      onClose: () => {
      }
    });
  };

  const onSetConfirmationCode = ({code}) => {
    setConfCode(code);
  };

  useEffect(() => {
    if (confCode && orderUuid) {
      onSubmitOrder();
    }
  }, [confCode]);

  const isAllPaymentTypesSelected = () => {
    return !persons.some(p => !p.paymentType);
  };

  const getPaymentData = () => {
    return persons.map((person) => {
      return {
        payment_type_id: person.paymentType.payment_type_id,
        amount: person.amount * 100,
        tips:  orderTips,
        card_number: person.cardData && person.cardData.cardNumber.replaceAll(/\s/g, ''),
        exp_date: person.cardData && `${person.cardData.expiryMonth} / ${person.cardData.expiryYear}`,
        cvv: person.cardData && person.cardData.cvc,
        passport_id: person.cardData && person.cardData.passport,
        pin_pad_id: (branchInfo.use_pin_pad_flg === 1) ? branchInfo.pin_pad_id : null,
        company_code: person.companyCode && person.companyCode.company_code
      };
    });
  };

  const isUserAmountValid = () => {
    const usersAmount = persons.reduce((acc, person) => {
      return acc + person.amount;
    }, 0);

    // const a = usersAmount * 100;
    // const b = a === orderTotalAmount;
    return Math.round(usersAmount * 100) === orderTotalAmount;
  };

  // const addTips = async () => {
  //   IPosModal.tipsModal({
  //     orderPaymentsSum: orderTotalAmount,
  //     t: t,        
  //     okButtonText: t('buttons.continue'),
  //     cancelButtonText: t('buttons.cancel'),
  //     onSubmit: (tipsAmount) => {
  //       setOrderTips(tipsAmount);
  //     },
  //     onClose: () => {
  //     }
  //   });
  // }

  // const addTips = () => {
  //   return new Promise((resolve, reject) => {
  //     if (currentTableId) {
  //       IPosModal.tipsModal({
  //         orderPaymentsSum: orderTotalAmount,
  //         t: t,
  //         okButtonText: t("buttons.continue"),
  //         cancelButtonText: t("buttons.cancel"),

  //         onSubmit: (tipsAmount) => {
  //           setOrderTips(tipsAmount);
  //           resolve(tipsAmount);
  //         },

  //         onClose: () => {
  //           setOrderTips(0);
  //           resolve(0);
  //         },
  //       });
  //     }
  //     else
  //     {
  //       setOrderTips(0);
  //       resolve(0);
  //     }
  //   });
  // };

  const onSubmitOrder = async () => {
    let loadingMessage = '';
    if (persons.some(p => p.paymentType && p.paymentType.payment_code === PaymentType.CREDIT_CARD) && branchInfo.use_pin_pad_flg === 1) {
      loadingMessage = t('payment.pin_pad_pay_loading_message');
    }

    showLoading(loadingMessage);
    if (!isAllPaymentTypesSelected()) {
      alert('Not all payment types selected');
      hideLoading();
      return;
    }

    if (!isUserAmountValid()) {
      hideLoading();
      IPosModal.alert({
        title: t('order.submit.error_title'),
        message: t('payment.errors.amount_not_equal', {totalAmount: orderTotalAmount / 100}),
        okButtonText: t('buttons.ok'),
        onOk: () => {
        }
      });

      return;
    }

    if (persons.some(p => !p.amount || p.amount === 0)) {
      hideLoading();
      IPosModal.alert({
        title: t('order.submit.error_title'),
        message: t('payment.errors.zero_amount'),
        okButtonText: t('buttons.ok'),
        onOk: () => {
        }
      });
      return;
    }

    // if (currentPaymentType && currentPaymentType.payment_code === PaymentType.CASH && !confCode && !orderUuid) {
    if (persons.some(p => p.paymentType && p.paymentType.payment_code === PaymentType.CASH) && !confCode && !orderUuid) {
      proceedCashCheckout();
      return;
    }

    // if (persons.some(p => p.paymentType && p.paymentType.payment_code === PaymentType.CREDIT_CARD))
    // {
    //     await addTips();
    // }

    let paymentData = getPaymentData();
    if (persons.some(p => p.paymentType && p.paymentType.payment_code === PaymentType.WAITER)) {
      paymentData = null;
    }    

    if (branchInfo.is_zcreditwc_flg === 1 && persons.some(p => p.paymentType && p.paymentType.payment_code === PaymentType.CREDIT_CARD)) {      
      const sessionInfo = await dejavooCreateSession();
      hideLoading();
      if (!sessionInfo || sessionInfo.error_message) {
        IPosModal.alert({
          title: '',
          message: formatError(!sessionInfo ? 'Something went wrong' : sessionInfo.error_message),
          okButtonText: t('buttons.ok'),
          onOk: () => {
          }
        });
        return;
      }

      // const sessionInfo = { SessionUrl: 'http://localhost:3000/i32b13f9-335s-9023-wm9j-5916344bff6r/payment-success?locale=en' };

      window.location = sessionInfo.SessionUrl;
      // window.open(sessionInfo.SessionUrl, '_blank', 'location=yes,height=800,width=720,scrollbars=yes,status=no');
      // setDejavooIframeUrl(sessionInfo.SessionUrl);
      // setCurrentView('dejavoo');
      return;
    }

    const res = await submitOrder(paymentData, orderUuid, confCode);
    hideLoading();
    if (!res || res.error_message) {
      IPosModal.alert({
        title: '',
        message: formatError(!res ? 'Something went wrong' : res.error_message),
        okButtonText: t('buttons.ok'),
        onOk: () => {
        }
      });
    } else {
      onSuccessPayment();
    }
  };

  const onSuccessPayment = () => {
    IPosModal.alert({
      title: t('order.submit.success_title'),
      message: branchInfo.use_pin_pad_flg === 1 ? t('order.submit.success_message') + t('order.submit.smile_message') : '',
      okButtonText: t('buttons.ok'),
      iconName: 'check-circle',
      closeOnBodyClick: true,
      onOk: () => {
        clearOrder();
        clearClientInfo();
        clearCostDelivery();
        setOrderType(null);
        setDeliveryType(null);
        setTableId(null);
        setOrderGuidCode('');
        setValueCardInfo(null), 
        setSelectedValueCardBenefits(null), 
        setValueCardBenefitsResponse(null), 
        setValueCardItem(null),
        setSelectedItem(null)
      }
    }, {modalClassName: 'confirmation-modal success-payment'});
  };

  const dejavooIframe = () => {
    return (
        <>
          <ZCreditWebCheckoutIframe iframeUrl={ dejavooIframeUrl } onSuccessCallback={ onSuccessPayment } />
          <div className={ 'actions-block' }>
            <div
                className={ 'btn btn-back' }
                onClick={ () => {
                  setDejavooIframeUrl(null);
                  setCurrentView('payments');
                } }
            >{t('buttons.back')}</div>
          </div>
        </>
    );
  };

  const isWaiter = persons.some(p => p.paymentType?.payment_code === PaymentType.WAITER);
  const total = ((Number(orderTotalAmount) + Number(orderTips)) / 100).toFixed(2);
  const tips = (Number(orderTips) / 100).toFixed(2);

  const paymentsContent = () => {
    return (
        <>
          <div className={ 'headline-block' }>
            <div className="headline">
              <span>{t('payment.title')}</span>
            </div>

            {/*<div className={ 'add_person_block' }>*/}
            {/*  <button*/}
            {/*    className={ 'btn btn-add-person' }*/}
            {/*    onClick={ () => {*/}
            {/*      addPerson(Object.assign({}, personObj, {uuid: Guid.create().value}));*/}
            {/*    } }*/}
            {/*    disabled={ persons.some(p => !p.amount || p.amount === 0) }*/}
            {/*  >*/}
            {/*    {t('payment.add_person')}*/}
            {/*  </button>*/}
            {/*</div>*/}
          </div>

          <SplitPaymentSelector
              persons={ persons }
              addPerson={ addPerson }
              removePerson={ removePerson }
              updatePerson={ updatePerson }
              orderTotalAmount={ orderTotalAmount }
              amountLeft={ amountLeft }
          />

          <div className={ 'actions-block' }>
            <div
                className={ 'btn btn-back' }
                onClick={ goBack }
            >{t('buttons.back')}</div>
            
            <button
                className={ 'btn btn-pay' }
                onClick={ onSubmitOrder }
                disabled={ !isDataValid() || (amountLeft !== 0 || persons.some(p => !p.amount || p.amount === 0)) }
            >
              {isWaiter ? (t('buttons.accept_order')) : (
                <>
                  <span>
                    {t('buttons.pay', { totalAmount: `${total} ₪` })}
                  </span>
                  {orderTips > 0 && (
                    <span className="span-tips">
                      {t('buttons.tips', { tipsAmount: `${tips} ₪` })}
                  </span>)}
                </>
              )}              
            </button>
          </div>
        </>
    );
  };

  return (
      <div className={ 'shop payment-page' } id="shop">

        {/* <div className="container"> */}

          {/* <div className={ 'row' }> */}
            <div className="payment-info">
              { currentView === 'payments' && paymentsContent() }
              { currentView === 'dejavoo' && dejavooIframe() }
            </div>

            <div className="order-info">
              <Cart editable={ false } />
            </div>
          {/* </div> */}

        {/* </div> */}

      </div>
  );
};

const mapStateToProps = (state) => {
  const {
    clientInfo,
    branchInfo,
    paymentTypes,
    currentTableId,
    orderTips,
    currentDeliveryType
  } = state;

  return {
    clientInfo,
    branchInfo,
    paymentTypes,
    currentTableId,
    orderTips,
    currentDeliveryType,
    orderTotalAmount: orderTotal(state)
  };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
          updateClientInfo,
          submitOrder,
          dejavooCreateSession,
          clearOrder,
          setDeliveryType,
          setOrderGuidCode,
          setOrderType,
          clearClientInfo,
          clearCostDelivery,
          sendConfirmationCode,
          setTableId,
          setOrderTips,
          showLoading, hideLoading,
          setValueCardInfo, 
          setSelectedValueCardBenefits, 
          setValueCardBenefitsResponse, 
          setValueCardItem,
          setSelectedItem
        },
        dispatch,
    );
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PaymentPage));
